module.exports = __webpack_public_path__ + "static/media/04.1c7394c6.mp3";